/* ASSESSMENT DETAILS */
export const GET_ALL_ASSESSMENT_DETAILS = "GET_ALL_ASSESSMENT_DETAILS"
export const GET_ALL_ASSESSMENT_DETAILS_SUCCESS = "GET_ALL_ASSESSMENT_DETAILS_SUCCESS"
export const GET_ALL_ASSESSMENT_DETAILS_FAIL = "GET_ALL_ASSESSMENT_DETAILS_FAIL"

export const GET_ASSESSMENT_RECORD = "GET_ASSESSMENT_RECORD"
export const GET_ASSESSMENT_RECORD_SUCCESS = "GET_ASSESSMENT_RECORD_SUCCESS"
export const GET_ASSESSMENT_RECORD_FAIL = "GET_ASSESSMENT_RECORD_FAIL"